<template>
    <div class="body-info body-content-description themed-scrollbar">
        <transition name="fade">
            <Notifications 
                v-if="notificationData"
                :msg-type="notificationData.type"
                :msg-text="notificationData.text"
            />
        </transition>
        <form v-if="!showTokenInput" class="vote-validation-form min-mode" :novalidate="true">
            <p class="mb-3 content-description"> {{ contentDescription }} </p>
            <div class="row mx-0 w-100">
                <div class="col-4 pl-0 pr-2 input-wrapper">
                    <SelectVue2 v-model="selectedCountry" :options="phoneIndicatives" :selected-default="defaultCountry" :input-label="kStrings.kCOUNTRY_INDICATIVE"/>
                </div>
                <div class="col-8 px-0 input-wrapper">
                    <input id="phoneSMS" v-model="phoneNumber" :type="modalData.content.inputs.phoneValidation.type" maxlength="50" class="normal-input" required/>
                    <label for="phoneSMS"> {{ kStrings.kPHONE_NUMBER }} </label>
                </div>
            </div>
            <div class="button-wrapper">
                <button class="pastime-button dark-mode" @click.prevent="validatePhone()" :disabled="!enableValidateButton"> {{ kStrings.kVALIDATE_PHONE }} </button>
            </div>
        </form>
        <form v-else class="vote-validation-form min-mode" :novalidate="true">
            <p class="mb-3 content-description"> {{ kStrings.kVALIDATE_PHONE_SMS_CODE }} </p>
            <div class="input-wrapper">
                <input id="smsToken" v-model="tokenValue" type="text" maxlength="50" class="normal-input" required/>
                <label for="smsToken"> {{ kStrings.kSMS_CODE }} </label>
            </div>
            <div class="button-wrapper">
                <button class="pastime-button dark-mode" @click.prevent="validateToken()" :disabled="!enableTokenButton"> {{ kStrings.kVALIDATE }} </button>
            </div>
        </form>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
import sharedApi from '@/api/sharedApi';
import request from '@/Utilities/httpRequest';

import SelectVue2 from '@/components/Muffin/SelectVue2';
import Notifications from '@/components/Pastimes/Desktop/partials/Notifications';

export default {
    store,
    name: 'SmsValidation',
    components: {
        SelectVue2,
        Notifications
    },
    props: {
        prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
            // phone validation
            selectedCountry: '',
            phoneNumber: '',
            tokenValue: '',
            showTokenInput: false
        }
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        urls() {
            return this.$store.getters.urls;
        },
        activePage() {
            return this.$store.getters.activePage;
        },
        contentDescription() {
            return this.activePage == 'voting' ? this.kStrings.kCHALLENGE_VALIDATE_VOTE : this.kStrings.kCHALLENGE_VALIDATE_REGISTER;
        },
        enableValidateButton() {
            return this.phoneNumber && this.phoneNumber.length >= 3;
        },
        enableTokenButton() {
            return this.tokenValue;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        //*** now that phone validation is in both register and voting, this could be put in the root store.
        notificationData() {
            return this.activePage == 'voting' ? this.$store.getters['contestantPage/notificationData'] : this.$store.getters['registrationPage/notificationData'];
        },
        notificationDispatch() {
            return this.activePage == 'voting' ? 'contestantPage/loadNotification' : 'registrationPage/loadNotification';
        },
        customerInfo() {
            return this.activePage == 'voting' ? this.$store.getters['contestantPage/customerInfo'] : this.$store.getters['registrationPage/customerInfo'];
        },
        countryOptions() {
            return this.activePage == 'voting' ? this.$store.getters['contestantPage/countryOptions'] : this.$store.getters['registrationPage/countryOptions'];
        },
        phoneIndicatives() {
            let pInd = this.activePage == 'voting' ? this.$store.getters['contestantPage/phoneIndicatives'] : this.$store.getters['registrationPage/phoneIndicatives'];
            return !isEmpty(pInd) ? pInd : this.pastimeInfo.phoneIndicatives;
        },
        //***
        defaultCountry() {
            return !isEmpty(this.customerInfo) ? this.customerInfo.currentStore.toUpperCase() : null;
        },
        selectedIndicative() {
            if(!this.selectedCountry) {
                return '';
            }
            
            let selIndicativeObject = this.phoneIndicatives.find(elm => elm.value == this.selectedCountry);
            return selIndicativeObject.indicative;
        }
        /*defaultPhoneNumber() {
            return !isEmpty(this.customerInfo) ? this.customerInfo.personalInfo.telephone : null;
        },*/
    },
    watch: {
        watched1(value) { }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            sharedApi.debug('phone indicatives: ', this.phoneIndicatives);
            this.setDefaults();
        });
    },
    methods: {
        async validatePhone() {
            this.$store.dispatch('setLoading', true);
            
            let url = this.modalData.content.buttons.submitPhoneNumber.url;
            let params = {
                socialPastimeId: this.pastimeInfo.baseInfo.id,
                number: this.phoneNumber,
                countryId: this.selectedCountry,
                indicative: this.selectedIndicative
            };
            sharedApi.debug('sms ws params: ', params);
            
            try {
                const {data} = await request.post(url, params, false);
                let hasError = data.hasError || isEmpty(data) || !data.validCountryPhone;
                let alreadyValid =  data.alreadyValid;
                sharedApi.debug('sms ws response: ', data);
                if(alreadyValid) {
                    this.$store.dispatch('setValidPhone', true);
                    this.$store.dispatch(this.notificationDispatch, {
                        type: 'info',
                        text: this.kStrings.kNUMBER_ALREADY_VALIDATED,
                        duration: 6000
                    });
                    this.$store.dispatch('setModalStatus', {status: false, context: null});
                } else {
                    if(!hasError) {
                        this.showTokenInput = true;
                    } else {
                        this.$store.dispatch(this.notificationDispatch, {
                            type: 'error',
                            text: this.kStrings.kPHONE_NUMBER_VALIDATION_ERROR,
                            duration: 6000
                        });
                    }
                }
                
            } catch (e) {
                sharedApi.logError(e);
                this.$store.dispatch(this.notificationDispatch, {
                    type: 'error',
                    text: this.kStrings.kGLOB_ERROR_MSG,
                    duration: 10000
                });
            } finally {
                this.$store.dispatch('setLoading', false);
            }
        },
        async validateToken() {
            this.$store.dispatch('setLoading', true);
            try {
                let tokenParams = {
                    socialPastimeId: this.pastimeInfo.baseInfo.id,
                    token: this.tokenValue,
                    number: this.phoneNumber,
                    indicative: this.selectedIndicative
                };
                // omfg betrayed by {data}
                const tokenRequest = await request.post(this.urls.submitSMScode, tokenParams, false);
                let tokenData = tokenRequest.data;
                sharedApi.debug('token ws response: ', tokenData);
                let tokenValid = !isEmpty(tokenData) && tokenData.valid;
                if(tokenValid) {
                    this.$store.dispatch('setValidPhone', true);
                    this.$store.dispatch(this.notificationDispatch, {
                        type: 'success',
                        text: this.kStrings.kPHONE_NUMBER_VALIDATED,
                        duration: 6000
                    });
                    this.$store.dispatch('setValidPhone', true);
                    this.$store.dispatch('setModalStatus', {status: false, context: null});
                } else {
                    this.$store.dispatch(this.notificationDispatch, {
                        type: 'error',
                        text: this.kStrings.kPHONE_NUMBER_VALIDATION_ERROR,
                        duration: 6000
                    });
                }
            } catch (e) {
                sharedApi.debug('error in sms token: ', e);
                sharedApi.logError(e);
                this.$store.dispatch(this.notificationDispatch, {
                    type: 'error',
                    text: this.kStrings.kGLOB_ERROR_MSG,
                    duration: 10000
                }); 
            } finally {
                this.$store.dispatch('setLoading', false);
            }
        },
        setDefaults() {
            this.selectedCountry = this.defaultCountry ? this.defaultCountry : this.countryOptions[0].value.toUpperCase();
            //this.phoneNumber = this.defaultPhoneNumber ? this.defaultPhoneNumber : '';
        },
    }
};
</script>

<style scoped>

</style>